<template>
  <div>
    <div class="row mt-2">
      <div class="col-md-6">
        <BreadCrumb :page="page" />
      </div>
      <div class="col-md-6">
        <div class="row">
          <div class="col-12">
            <div class="d-flex justify-content-end">
              <ActionButton
                variant="outline-success mr-2"
                i="fas fa-arrow-circle-left"
                :text="
                  `${fromRoute.from != null ? fromRoute.from : 'Regresar'}`
                "
                @click="navigate"
              />
              <ActionButton
                v-if="submitted && showSection"
                i="fas fa-print"
                variant="btn btn-green success"
                @click="
                  goToDownloadEE05Report(
                    evaluationDateId,
                    eligibilityDetermination.isElegibility
                  )
                "
              >
                Imprimir
              </ActionButton>
              <ActionButton
                v-if="canShowSaveButton"
                type="submit"
                variant="success mr-2"
                i="fas fa-save"
                :disabled="participantSignaturesSaving"
                @click="handleSaveAction"
              >
                Guardar
              </ActionButton>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Separator -->
    <div class="col-12 dropdown-divider pb-4 w-100" />

    <div class="w-100" :class="isDisabled ? 'wrapper-block' : ''">
      <div>
        <!-- :class="isDisabled ? 'disabled-page' : ''"> -->
        <!-- Informacion General -->
        <div class="col-12">
          <SectionTitle
            has-line
            content="Determinación de Elegibilidad Trianual del estudiante"
          />
        </div>
        <div class="col-12">
          <ValidationObserver ref="generalInformationEligiblityA">
            <GeneralInformationEligibility
              v-model="generalInformationEligibility"
              :is-from-determination="isFromDetermination"
              :last-evaluation-date="new Date(lastEvalDate)"
              :disabled="submitted || isFromDetailCoordination"
              :isOnlyDate="true"
              :show-is-sufficient-flag="
                generalInformationEligibility.showSufficientFlag
              "
            />
          </ValidationObserver>
        </div>
        <div v-if="generalInformationEligibility.enoughInformation">
          <div class="col-12">
            <SectionTitle
              has-line
              content="Documentos Evaluados en el Análisis de información Existente"
            />
          </div>
          <div class="col-12">
            <EvaluationDocuments
              ref="evaluationDocumentsBackup"
              :student-sie-id="selectedStudentSieId"
              :evaluation-date="generalInformationEligibility.evaluationDate"
              :isSubmitted="submitted || !canPost"
              :current-documents="analysisDocumentsSaved"
              @on-add-document="gettingBackupDocumentAnalysys"
            />
          </div>
        </div>
        <!-- Separator -->
        <div class="dropdown-divider mt-0 pb-4 w-100" />
        <!-- Informacion de Evaluaciones -->
        <div
          class="col-12"
          v-if="generalInformationEligibility.enoughInformation"
        >
          <SectionTitle
            has-line
            content="Criterio 1: Información de Evaluaciones"
          />

          <Error
            v-if="validateComponent && showErrorEvaluations"
            message="Es necesario que seleccione al menos una evaluación durante la discusión."
            variant="withoutspacing"
          />
          <Error
            v-if="
              validateComponent &&
                !showErrorEvaluations &&
                existInvalidEvaluationReject
            "
            message="Es necesario documentar la razón por la que no se aceptó la evaluacion(es) seleccionada(s)."
            variant="error"
          />

          <div class="mx-3">
            <ValidationObserver ref="evaluationInformation">
              <EvaluationInformation
                v-model="evaluationInformationLayout"
                :has-option-determinate="true"
                :evaluation-saved="submitted"
                :error="evaluationErrorMessage"
                :enoughInformation="isNotEnoughtInformation"
                :get-evaluations="getEvaluationInfoAndAvailable"
                :register="
                  !generalInformationEligibility.enoughInformation
                    ? lastRegisterOrEvaluation
                    : []
                "
                :disabled="isDisabled || !canPost"
                :show-as-discussion="showAsDiscussion"
                :discussionCollections="discussionCollections"
                @evaluationsModalSaveHandler="
                  selectedEvaluationsModalSaveHandler
                "
                @addPreviousEvaluation="showAddPreviousModal"
                @go-to-add-student-evaluation="goToAddStudentEvaluation"
              />
            </ValidationObserver>

            <AddPreviousEvaluationsModal
              v-if="openModal"
              @state="(s) => (openModal = s)"
              @refresh="(v) => loadEvaluations(v)"
            />
          </div>
        </div>
        <!-- Documentos de Respaldo al Proceso de Determinacion -->
        <div
          class="col-12"
          v-if="generalInformationEligibility.enoughInformation"
        >
          <SectionTitle
            has-line
            content="Criterio 2: Documentos de Respaldo para Dificultad Académica"
          />
          <ValidationObserver ref="backupDocument">
            <BackupDocument
              :documents="existingDocuments"
              :show="Number($route.params.evaluationDateId)"
              :disabled="submitted || !canPost"
              :read-only="submitted"
              :has-error="!isCriteriaDocumentsValid"
              @files="gettingBackupDocument"
              @file-not-found="fileNotFound"
            />
          </ValidationObserver>
        </div>
        <!-- FIn Documento de Respaldo -->

        <div v-if="generalInformationEligibility.showSufficientFlag">
          <!-- Resultado del Análisis -->
          <div class="col-12">
            <SectionTitle has-line content="Resultado del Análisis" />
          </div>
          <div class="col-12">
            <ValidationObserver ref="generalInformationEligiblityB">
              <GeneralInformationEligibility
                v-model="generalInformationEligibility"
                :is-from-determination="isFromDetermination"
                :last-evaluation-date="new Date(lastEvalDate)"
                :disabled="isDisabled || isFromDetailCoordination || !canPost"
                :isOnlyDate="false"
                :show-is-sufficient-flag="
                  generalInformationEligibility.showSufficientFlag
                "
              />
            </ValidationObserver>
          </div>
        </div>
        <!-- Determinación de Elegibilidad Triannual -->
        <div
          v-if="generalInformationEligibility.enoughInformation"
          class="row mb-4"
        >
          <div class="col">
            <ValidationObserver ref="eligibilityDetermination">
              <EligibilityDeterminationTriannual
                v-model="eligibilityDetermination"
                :placementCommitteId="placementCommitteId"
                ref="EligibilityDeterminationTriannual"
                :called-from="'Triannual'"
                :date-registration="
                  generalInformationEligibility.evaluationDate != null
                    ? generalInformationEligibility.evaluationDate
                    : new Date()
                "
                :show-intervention-questionnaire="false"
                :determination-options="determinationElegibilityOptions"
                :disabled="isDisabled || !canPost"
                has-validation-pending
              />
            </ValidationObserver>
          </div>

          <div v-if="additionalQuestionsFlag" class="mt-4 col-12">
            <div class="col">
              <additional-questions
                ref="additionalQuestions"
                :academic-year="academicYear"
                class="mb-4"
              />
            </div>
          </div>
        </div>

        <!-- Separator -->
        <!-- Referido para solicitud de evaluación -->
        <div v-if="isNotEnoughtInformation" class="separator">
          <div class="col">
            <SectionTitle
              content="Referido para solicitud de evaluación"
              :has-line="true"
            />
            <!-- JM: Se debe tratar de cambiar el force de :key para hacer un refresh -->
            <ReferralForEvaluationRequest
              :key="requestReferrals.referralForEvaluationRequestKey"
              ref="ReferralForEvaluationRequest"
              v-model="referrals"
              :has-error="
                hasSelectedReferralTrianual != undefined &&
                  hasSelectedReferralTrianual == false
              "
              :submitted="submitted === 'true'"
              :isFromDetailCoordination="isFromDetailCoordination"
              :sie="sieByParam"
              :disabled="false"
              @on-referrals="validateReferrals($event)"
              @downloadReferralReport="downloadReferralReport($event)"
            />
          </div>
        </div>
        <!-- End Referido para solicitud de evaluación -->
        <!-- Doumentos a realizar para identificar si presenta dificultad para progresar académicamente -->
        <div v-if="isNotEnoughtInformation" class="col-12">
          <SectionTitle
            :has-line="true"
            content="Documentos a realizar para identificar si presenta dificultad para progresar académicamente"
          />
          <DocumentsByDIfficulty
            v-if="optionsDifficult.length > 0"
            :key="optionsDifficult.length"
            :existDifficulySelected="difficulySelectedtExist"
            :reevaluationTime="placementComitteReevaluationTime"
            :isFromDetailCoordination="true"
            @difficultyList="getDifficulty"
            @optionOther="getOtherOption"
            @getQuantity="getQuantity"
            ref="documentDifficult"
            id="documentDifficult"
            :options="optionsDifficult"
          />
          <br />
        </div>
        <!-- Firma de Participantes -->
        <div v-if="shouldShowParticipantSignatures" class="col-12">
          <SectionTitle has-line content="Firma de Participantes" />
          <ValidationObserver ref="signatureObserver" slim>
            <Tab9ParticipantSignatures
              ref="participantSignatures"
              :key="componentKey"
              :value="signatureList"
              :options="availableSignatureOptions"
              :is-draft="participantSignaturesIsDraft"
              :readOnly="participantSignaturesReadOnly"
              :participation-types="participationTypeList"
              :alternate-participations="alternateParticipationTypeList"
              @addSignature="addSignature()"
              @deleteSignature="deleteSignature"
            />
          </ValidationObserver>
        </div>
        <!-- Certificación de procedimientos -->
        <ValidationObserver ref="termsResponsability">
          <!-- Certificación de procedimientos -->
          <div class="mt-5">
            <div class="mt-3 tag-badge pl-2">
              <span class="dot text-center">
                <i
                  class="far fa-check-circle orange-icon orange-icon-badge-align"
                />
              </span>
              <span class="tag-badge-title py-1 pl-2">
                Certificación de procedimientos
              </span>
            </div>
          </div>
          <div class="row mx-1">
            <div class="col-12 px-1">
              <div class="border-box">
                Certifico por este medio, que este referido podrá encontrarse en
                el expediente físico del estudiante firmado por todas las partes
                involucradas. (0502)
              </div>
            </div>
            <div class="col-12 px-0">
              <ValidationProvider
                v-slot="{ errors }"
                name="checkboxConditions"
                rules="required"
              >
                <div class="row mx-1">
                  <div
                    class="border-box gray"
                    :class="{ error: errors.length > 0 }"
                  >
                    <div class="col-12 px-0 py-0">
                      <div class="custom-control custom-checkbox">
                        <div class="custom-control custom-checkbox">
                          <input
                            id="checkboxConditions"
                            v-model="info.termsAccepted"
                            :disabled="isDisabled || !canPost || submitted"
                            type="checkbox"
                            class="custom-control-input"
                            name="checkboxConditions"
                          />
                          <label
                            class="custom-control-label pl-3"
                            for="checkboxConditions"
                          >
                            Acepto
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-show="errors.length > 0" class="row mt-1">
                    <div class="col-12">
                      <i class="fa fa-times-circle text-red pr-2" />
                      <span class="invalid">
                        Favor certificar los términos y responsabilidades
                      </span>
                    </div>
                  </div>
                </div>
              </ValidationProvider>
            </div>
          </div>
        </ValidationObserver>
        <CustomHR variant="none" />
        <CustomHR variant="success" />
        <footer-buttons>
          <div slot="buttons" class="mv">
            <ActionButton
              v-if="canPost && !isDisabled"
              variant="success"
              i="fas fa-save"
              type="submit"
              @click="handleSubmit"
            >
              Guardar
            </ActionButton>
          </div>
        </footer-buttons>
        <custom-contact-info-modal
          ref="contactInfoModalRef"
          :studentSieParam="sieByParam"
          @cancel="cancelContactInfoModal"
          @save="saveContactInfoModal"
        />
      </div>
    </div>
  </div>
</template>

<script>
import store from '@/store/index';
import reportService from '@/services/report';

//Luego refactoring para que el componente quede a nivel de vista ya que es unico
import CustomContactInfoModal from '@/components/common/CustomContactInfoModal';
import GeneralInformationEligibility from '@/components/triannualDeterminationProcess/components/GeneralInformationEligibility';
import ReferralForEvaluationRequest from '@/components/triannualDeterminationProcess/components/ReferralForEvaluationRequest';
import BackupDocument from '@/components/studentEvaluation/BackupDocument';
import EvaluationInformation from '@/components/studentEvaluation/EvaluationInformation';
import AddPreviousEvaluationsModal from '@/components/studentEvaluation/AddPreviousEvaluationsModal';
import EligibilityDeterminationTriannual from '@/components/triannualDeterminationProcess/components/EligibilityDeterminationV2';
import Tab9ParticipantSignatures from '@/components/pei/tabs/components/Tab9/participantSignatures/Tab9ParticipantSignatures';
import EvaluationDocuments from './components/EvaluationDocumentBackup.vue';
//Importar los componentes comunes de verdaccio y quizas colocarlo en un .index para importarlo todos
import Error from 'custom-error';
import { SectionTitle } from '@/components/pei/shared';
import BreadCrumb from '@/components/common/page/TitleBreadcrumb';
import ActionButton from 'ActionButton';
import CustomHR from '@/components/common/page/CustomHR';
import CustomTextArea from '@/components/common/CustomTextArea';
import FooterButtons from '@/components/common/FooterButtons';

import { ValidationObserver } from 'vee-validate';
import objectToFormData from 'object-to-formdata';
import loading from '@/mixin/loading.mixin';

import alertMixin from '@/mixin/alert.mixin';
import participantSignaturesMixin, {
  resolveTriannualParticipantSignatureSources,
} from './participantSignatures.mixin';

//Enums
import evaluationTypes from '@/utils/constants/student/evaluationTypes';
import placementCommitteeCategory from '@/utils/constants/student/placementCommitteeCategory';
import ImpedimentsEnum from '@/utils/constants/reg/impedimentsType';
const evaluationDateTypeCodes = {
  existingEvaluationAnalysis: 312,
  triannualReview: 313,
};
import DISCIPLINE_TYPES from '@/utils/constants/disciplineTypes';

//Apis or Services
import generalService from '@/services/pei/general';
import resourcesService from '@/services/resources.js';
import signatureService from '@/modules/common/signature.api';
import studentEvaluationService from '@/modules/student-evaluations/api.js';
import studentTrianualService from '@/modules/student-trianual/api.js';
import compuHistoryServices from '@/modules/student-compu-history/api';
import AdditionalQuestions from '.././components/AdditionalQuestions';
import { discussionStatuses } from '@/utils/constants/evaluation-discussion/discussionStatusCode';
import DocumentsByDIfficulty from '.././components/DocumentsByDIfficulty';
import {
  getAcademicDifficultyProgress,
  getSysparameterByNames,
} from '@/modules/system-parameter-managment/api';
import studentEvaluationServices from '@/modules/student-evaluation-request-managment/api.js';
import {
  getEvaluationDiscussionStatus,
  getRejectionReasonsV2,
} from '@/modules/common/code.api.js';

const DEAFULT_MSG_ERROR =
  'Ha ocurrido un error mientras se procesaba la información.';
const OTHER = 8;
export default {
  prop: {
    throwSave: {
      type: Boolean,
      default: false,
    },
  },
  mixins: [loading, alertMixin, participantSignaturesMixin],
  components: {
    BreadCrumb,
    DocumentsByDIfficulty,
    EvaluationDocuments,
    GeneralInformationEligibility,
    BackupDocument,
    ReferralForEvaluationRequest,
    EvaluationInformation,
    AddPreviousEvaluationsModal,
    ActionButton,
    CustomHR,
    CustomTextArea,
    ValidationObserver,
    FooterButtons,
    SectionTitle,
    EligibilityDeterminationTriannual,
    Tab9ParticipantSignatures,
    CustomContactInfoModal,
    Error,
    AdditionalQuestions,
  },
  data() {
    return {
      tempEvaluations: [],
      canPost: false,
      page: {
        icon: 'fas fa-user-circle',
        title: 'Proceso Determinación Trianual',
        routes: ['Inicio', 'Estudiante', 'Proceso Determinación Trianual'],
      },
      hasCriterial2Error: null,
      lastRegisterOrEvaluation: [],
      placementCommitteId: null,
      additionalQuestionsFlag: false,
      isElegibility: null,
      optionsDifficult: [],
      difficultyProgress: [],
      otherInput: null,
      reevaluationTime: null,
      analysisDocuments: [],
      analysisDocumentsSaved: [],
      difficulySelectedtExist: [],
      placementComitteReevaluationTime: null,
      // * IF ADD SOME PROPERTY TO MODEL REMEMBER METHOD RESET
      //Disabled Forms and common variables
      submitted: false,
      evaluationDateId: undefined,
      isFromDetermination: false,
      lastEvalDate: undefined,
      shouldValidate: false, // TODO: We need search alternative for components than used this :S
      // Section Zero
      studentContactInformation: null, //Contact Information only filled when is enought
      //Section I
      generalInformationEligibility: {
        academicYearId: null,
        academicYearDescription: null,
        evaluationDate: null,
        enoughInformation: null,
        showSufficientFlag: true,
      },
      evaluationDescription: null,
      // End Section
      //Section II (Documentos de Respaldo)
      existingDocuments: {
        files: [],
        types: [],
      },
      // !Repeat?
      backupDocumentsData: {
        files: [],
        types: [],
      },
      //End Section II
      //Section III  (Referido para solicitud de evaluacion)
      requestReferrals: {
        referrals: [],
        referralForEvaluationRequestKey: 0,
      },
      hasSelectedReferralTrianual: null,
      // End Section III
      //Section IV (Informacion de Evaluaciones)
      existInvalidEvaluationReject: false,
      //Evaluation Information for Evaluation Information Layout
      evaluationInformationLayout: {
        evaluationsAddedList: [],
        availables: [],
        evaluationInformationData: [],
      },
      openModal: false, //Add Previous Evaluations
      evaluationErrorMessage: null,
      //End Section IV
      //Section V (Determinacion)
      determinationElegibilityOptions: {
        impediments: [],
        notImpediments: [],
        severities: [],
        disorders: [],
        multipleImpediments: [],
        conditions: [],
      },
      determinationElegibilityOptionsOriginal: [],
      eligibilityDetermination: {
        impedimentsOptions: [],
        dateEligibility: null, // type: [Date, String],
        isElegibility: null,
        dissabilityOption: null, //int
        comments: '', //String
        meetingQty: null, //Object
        isHealthSpecialistNecessary: null, //Bool
        isConditionsInProcessNecessary: null, //Bool
        participatedSpecialist: null, //Bool
        certification: null,
        impediment: null,
        severity: null,
        disorders: null,
        partialHearing: null,
        //Multiple
        impedimentMultiple: {
          impediment: null,
          selectedItems: [],
        }, //Object
        severityMultiple: null,
        disordersMultiple: null, //Object
        partialHearingMultiple: null, //Object,
        eligibilityDeterminationConditions: {
          condition: null,
          selectedItems: [],
        },
      },
      impedimentRequireMultipleEvaluations: [],
      impedimentRequireEvaluations: [],
      //End Section V
      //Section VI (Firmas)
      //signature Managment properties
      signatureCounter: 0,
      signatureList: [],
      signatureListWithoutCometee: [],
      evaluationDateId: null,
      signatures: [],
      elegibilitySignatureList: null,
      componentKey: 0,
      availableSignatureOptions: [],
      participationTypeList: [],
      alternateParticipationTypeList: [],
      //End Section VI
      //Section VII Terminos
      info: {
        termsAccepted: this.evaluationDateId != null ? true : null,
      },
      //End Section VII
      placementCommitteeCategoryId:
        placementCommitteeCategory.EvaluacionAdicional,
      evaluationDateTypeCode: 313,
      errorMsgs: {
        comment: '',
      },
      // Validar propiedades fuera de VeeValidate.
      validateComponent: false,
      // Flag para indicar que se ha guardado.
      resources: [],
      originalReferralsCount: null,
      showErrorEvaluations: false,
      isCriteriaDocumentsValid: true,
      sieByParam: null,
      isFromDetailCoordination: null,
      isAdd: null,
      showAsDiscussion: false,
      discussionCollections: {
        discussionStatuses: [],
        rejectionReasons: [],
        allRejectionReasons: [],
      },
    };
  },
  async mounted() {
    await resourcesService
      .LoadValidationMessages([
        '17306',
        '22124',
        '150',
        'R90006',
        '22144',
        '22145',
        '22146',
        '22147',
        '22148',
        '22149',
        '22150',
        'R140001',
        'R140002',
      ])
      .then((result) => {
        this.resources = result;
      });
    // * Set All this in One Promise
    await this.loadInfo();
    await this.getEvaluationInformation(
      [],
      [],
      null,
      null,
      null,
      this.evaluationDateId || null
    );
    if (this.evaluationDateId) {
      await this.getAvailablesEvaluations();
    } else {
      this.preSelectAvailables();
    }

    if (this.$store.getters.triannualEvaluation) {
      this.recoverEditedData();
      await this.getAvailablesEvaluations();
      const added = this.tempEvaluations
        .filter(
          (x) =>
            !this.evaluationInformationLayout.evaluationInformationData.some(
              (e) => e.studentEvaluationId === x.studentEvaluationId
            )
        )
        .filter((x) => x.validForDiscussion === !this.submitted);
      if (added.length > 0) {
        this.evaluationInformationLayout.evaluationInformationData.unshift(
          added[0]
        );
      }
      const listIds = this.evaluationInformationLayout.evaluationInformationData?.map(
        (x) => x.studentEvaluationId.toString()
      );
      this.evaluationInformationLayout.availables =
        this.evaluationInformationLayout.availables?.filter(
          (x) => !listIds.includes(x.value)
        ) || [];
      this.$store.commit('setTriannualEvaluation', null);
    }
  },
  methods: {
    preSelectAvailables() {
      const selected = this.tempEvaluations.filter(
        (x) => x.validForDiscussion === !this.submitted
      );
      this.evaluationInformationLayout.evaluationInformationData = selected;

      const listIds = selected?.map((x) => x.studentEvaluationId.toString());
      this.evaluationInformationLayout.availables =
        this.evaluationInformationLayout.availables?.filter(
          (x) => !listIds.includes(x.value)
        ) || [];
    },
    async getAsDiscussionData() {
      await this.getShowEvaluationDeterminationAsDiscussionParam();
      if (!this.showAsDiscussion) return;
      await this.loadDiscussionStatuses();
      await this.loadRejectionReasons();
    },
    async getShowEvaluationDeterminationAsDiscussionParam() {
      const { data } = await getSysparameterByNames({
        parameterNames: ['ShowEvaluationDeterminationAsDiscussion'],
      });

      this.showAsDiscussion =
        data?.length > 0 && data[0].staticValue?.toLowerCase() == 'true';
    },
    async loadDiscussionStatuses() {
      const { data } = await getEvaluationDiscussionStatus();
      this.discussionCollections.discussionStatuses = [...data];
    },
    async loadRejectionReasons() {
      const { data } = await getRejectionReasonsV2();
      this.discussionCollections.rejectionReasons = [...data];
      this.discussionCollections.allRejectionReasons = [...data];
    },
    getDifficulty(val) {
      this.difficultyProgress = val.map((obj) => ({
        comment: obj.id == OTHER ? this.otherInput : '',
        academicDifficultyProgressTypeId: obj.id,
      }));
    },
    getOtherOption(val) {
      this.otherInput = val;
      this.difficultyProgress.forEach((item) => {
        if (OTHER == item.academicDifficultyProgressTypeId) {
          item.comment = val;
        }
      });
    },
    getQuantity(val) {
      this.reevaluationTime = val;
    },
    async loadInfo() {
      //Get Impediments required Multiples Evaluations
      await this.getAsDiscussionData();
      let result = await getAcademicDifficultyProgress();
      this.optionsDifficult = result.data;
      //Set Data
      this.errorMsgs.comment = this.resources['17306'];
      // TODO unified every querystring or reduce
      //Routes (Change for FromRoute)
      this.sieByParam = this.$route.query.studentSieId;
      this.getItems();
      await studentTrianualService
        .getRequiredMultipleImpediments()
        .then((response) => {
          this.impedimentRequireMultipleEvaluations = response.data;
        });

      await studentTrianualService
        .getImpedimentsEvaluations()
        .then((response) => {
          this.impedimentRequireEvaluations = response.data;
        });
      await this.getImpedimentOptions();
      await this.getConditionsCatalog();
      //Load all Signatures (because we need load data if loaded)
      await this.getParticipationTypeList();
      await this.getAlternateParticipationTypeList();
      await this.setSignatureConfig();

      this.isFromDetailCoordination =
        this.$route.query.isFromDetailCoordination?.toString() === 'true'
          ? true
          : false;
      if (this.fromRoute.headerTitle != undefined) {
        this.page.title = this.fromRoute.headerTitle;
      }
      if (this.$route.query.isFromDetermination != undefined) {
        this.isFromDetermination =
          this.$route.query.isFromDetermination == 'true';
      }
      if (this.$route.query.lastEvalDate != undefined) {
        this.lastEvalDate = new Date(this.$route.query.lastEvalDate);
        this.isFromDetermination = true;
      }
      //Load Components for triannual
      // Update hidden fields and pre-selected
      if (this.$route.query.update == 1) {
        this.generalInformationEligibility.showSufficientFlag = false;
        this.generalInformationEligibility.enoughInformation = true;
      }
      if (this.$route.query.isSubmitted != undefined) {
        this.submitted = this.$route.query.isSubmitted;
      }

      if (this.$route.params.evaluationDateId) {
        this.evaluationDateId = this.$route.params.evaluationDateId;
        //Load documents
        let self = this;
        await studentTrianualService
          .getExistingDocuments(this.$route.params.evaluationDateId)
          .then((response) => {
            if (response.data.elegibilityInfo) {
              response.data.elegibilityInfo.documentAttachmentInfo.map(
                (element) => {
                  self.existingDocuments.files.push({
                    name: element.filename,
                    id: element.documentId,
                    inServer: true,
                  });
                  self.existingDocuments.types.push({
                    typeId: element.documentTypeId,
                    documentRawDate: element.documentDate,
                    disciplineTypeName: element.documentDisciplineTypeName,
                  });
                }
              );
            }
          });
        const {
          data: difficulySelectedtExist,
        } = await studentEvaluationService.getDifficult(
          this.$route.params.evaluationDateId
        );
        this.difficulySelectedtExist = difficulySelectedtExist;
        await this.getEvaluationDateInfo(this.$route.params.evaluationDateId);
        //Get Evaluations Previamente seleccionada
        await this.getEvaluationInformation(
          [],
          [],
          null,
          null,
          null,
          this.$route.params.evaluationDateId
        );
      } else {
        await this.getAvailablesEvaluations();
      }
    },
    async saveEditedData() {
      this.$store.commit('setTriannualEvaluation', {
        generalInformationEligibility: this.generalInformationEligibility,
        evaluationInformationLayout: this.evaluationInformationLayout,
        analysisDocumentsSaved: this.analysisDocumentsSaved,
        existingDocuments: this.existingDocuments,
        requestReferrals: this.requestReferrals,
        eligibilityDetermination: this.eligibilityDetermination,
        signatureList: this.signatureList,
        info: this.info,
        difficulySelectedtExist: this.difficulySelectedtExist,
        placementComitteReevaluationTime: this.placementComitteReevaluationTime,
      });
    },
    recoverEditedData() {
      const triannualEvaluation = this.$store.getters.triannualEvaluation;
      if (triannualEvaluation) {
        this.generalInformationEligibility =
          triannualEvaluation.generalInformationEligibility;
        this.evaluationInformationLayout =
          triannualEvaluation.evaluationInformationLayout;
        this.analysisDocumentsSaved =
          triannualEvaluation.analysisDocumentsSaved;
        this.existingDocuments = triannualEvaluation.existingDocuments;
        this.requestReferrals = triannualEvaluation.requestReferrals;
        this.eligibilityDetermination =
          triannualEvaluation.eligibilityDetermination;
        this.signatureList = triannualEvaluation.signatureList;
        this.info = triannualEvaluation.info;
        this.difficulySelectedtExist =
          triannualEvaluation.difficulySelectedtExist;
        this.placementComitteReevaluationTime =
          triannualEvaluation.placementComitteReevaluationTime;
      }
    },
    goToAddStudentEvaluation() {
      this.saveEditedData();

      this.$router.push({
        name: 'student-evaluation-history-add',
        query: {
          from: this.$route.fullPath,
          studentSieId: this.$store.getters.SelectedStudent.studentId,
          discussionMode: this.$route.params.evaluationDateId ? '2' : '1',
        },
      });
    },
    fileNotFound(data) {
      this.hasCriterial2Error = data.error;
    },
    downloadReferralReport(data) {
      if (data.length === 0) return;

      const referral = data[0];
      reportService.downloadReferralReport(referral.studentReferralId);
    },
    async loadEvaluations(addedRecentlyId) {
      if (!this.$route.params.evaluationDateId) {
        const evauationSelectedOrRegister = await studentTrianualService.getEvauationSelectedOrRegister(
          this.$store.getters.SelectedStudent.studentId,
          this.generalInformationEligibility.academicYearId
        );
        evauationSelectedOrRegister.data.forEach((e) => {
          e.editable = e.statusId == -1 && e.isApprovedByParentFlag == null;
          //The evaluations can discuss again for trianual
          e.editable = [
            'Previa',
            'Confirmada',
            'Realizada por Remedio Provisional',
          ].includes(e.statusName);
          e.isSelectedFlag = e.isDeterminated = e.isImpedimentEvaluationFlag;
          e.isSelectedFlag = e.isApprovedByParentFlag != null;
          //Vm for Reject section
          e.isAcceptedDisabled = e.isApprovedByParentFlag != null;
          e.rejection = {
            rejectionById: { id: e.rejectionById, name: e.rejectionByName },
            rejectionComment: e.rejectionComment,
          };
          e.isOpened = false;
        });
        let data = [...evauationSelectedOrRegister.data];
        this.lastRegisterOrEvaluation = data;
        // JSF: commented this line because it's making the save method to stop work properly
        // in the next US will make this to work as it was expected.
        //this.evaluationInformationLayout.evaluationInformationData  = this.lastRegisterOrEvaluation
      } else if (!this.generalInformationEligibility?.enoughInformation) {
        await this.getEvaluationInformation(
          [],
          [],
          null,
          null,
          null,
          this.$route.params.evaluationDateId
        );
        await this.getAvailablesEvaluations();
      }

      const addeds = this.evaluationInformationLayout.evaluationInformationData.map(
        (x) => x.studentEvaluationId
      );
      addeds.unshift(addedRecentlyId);
      this.saveEditedData();
      await this.getEvaluationInfoAndAvailable(
        addeds.map((x) => ({
          value: x,
        })),
        this.evaluationInformationLayout.availables
      );
      this.recoverEditedData();
      const listIds = this.evaluationInformationLayout.evaluationInformationData?.map(
        (x) => x.studentEvaluationId.toString()
      );
      this.evaluationInformationLayout.availables =
        this.evaluationInformationLayout.availables?.filter(
          (x) => !listIds.includes(x.value)
        ) || [];
      this.$store.commit('setTriannualEvaluation', null);
    },
    async getEvaluationInfoAndAvailable(
      evaluationsAddedList,
      evaluationsExcludedList = undefined
    ) {
      await this.getEvaluationInformation(
        evaluationsAddedList,
        evaluationsExcludedList
      );
      await this.getAvailablesEvaluations();
    },
    async getItems() {
      this.$ApiGet(
        `/api/triannualstudentevaluation/${this.selectedStudentSieId}/selectedevaluations/0`
      ).then((response) => {
        if (this.$route.query.isAdd) {
          this.canPost = true;
        } else {
          if (
            response.data[0].isEligibilityFlag == true &&
            response.data[0].isSufficientFlag == true
          ) {
            this.canPost = false;
          } else {
            this.canPost = true;
          }
        }
      });
    },
    //Section Completed
    async getEvaluationDateInfo(id) {
      await studentTrianualService.getEvaluation(id).then(async (response) => {
        this.triennialPlacementCommitteId =
          response.data.triennialPlacementCommitteId;
        this.evaluationDateInfoLoaded = true;
        this.placementCommitteId = response.data.placementCommittee
          ? response.data.placementCommittee.placementCommitteId
          : null;
        this.placementComitteReevaluationTime = response.data.reevaluationTime;
        //Convert to component data
        this.analysisDocumentsSaved = response.data.documentAnalysis;
        this.generalInformationEligibility.academicYearId =
          response.data.academicYearId;
        this.generalInformationEligibility.academicYearDescription =
          response.data.academicYearDesc;
        this.generalInformationEligibility.evaluationDate =
          this.isFromDetermination && response.data.elegibilityInfo
            ? new Date(
                response.data.elegibilityInfo.eligibilityDeterminationDate
              )
            : new Date(response.data.evaluationDate);
        this.generalInformationEligibility.enoughInformation =
          this.isFromDetermination || response.data.isSufficientFlag === '1';
        this.evaluationDescription = response.data.commentDescription;
        //Evaluation Refferals
        this.requestReferrals.referrals = response.data.referrals;
        this.originalReferralsCount = this.requestReferrals.referrals.length;
        this.evaluationDateId = response.data.evaluationDateId;
        this.info.termsAccepted = this.isDisabled || this.submitted;
        //getDoc
        if (response.data.peiEvaluationDateDocumentList.lenght != 0) {
          response.data.peiEvaluationDateDocumentList.map((element) => {
            this.existingDocuments.files.push({
              name: element.filename,
              id: element.documentId,
              inServer: true,
            });
            this.existingDocuments.types.push({
              type: element.documentTypeId,
              disciplineTypeName: element.documentDisciplineTypeName,
              documentRawDate:
                element.placementCommitteeDocumentGuarantee.documentDate,
            });
          });
        }
        //ElegibityDetermination
        const elegibilityInfo = response.data.elegibilityInfo;
        const signatureSources = resolveTriannualParticipantSignatureSources({
          elegibilityInfo,
          signatures: response.data.signatures,
        });
        this.signatureListWithoutCometee =
          signatureSources.signatureListWithoutCometee;
        this.elegibilitySignatureList =
          signatureSources.elegibilitySignatureList;
        await this.setSignatureConfig();
        if (elegibilityInfo) {
          this.eligibilityDetermination.dateEligibility = new Date(
            elegibilityInfo.eligibilityDeterminationDate
          );
          this.eligibilityDetermination.isElegibility =
            elegibilityInfo.eligibilityFlag != null
              ? elegibilityInfo.eligibilityFlag === '1'
              : null;

          this.eligibilityDetermination.dissabilityOption =
            elegibilityInfo.dissabilityOption;

          this.eligibilityDetermination.comments =
            elegibilityInfo.eligibilityComment;
          if (elegibilityInfo.postEligibilityMeetingsQty) {
            this.eligibilityDetermination.meetingQty = {
              id: elegibilityInfo.postEligibilityMeetingsQty,
              name: elegibilityInfo.postEligibilityMeetingsQty,
            };
          }

        this.eligibilityDetermination.isHealthSpecialistNecessary =
          elegibilityInfo.healthSpecialistParticipationFlag != null
            ? elegibilityInfo.healthSpecialistParticipationFlag === '1'
            : null;

        this.eligibilityDetermination.participatedSpecialist =
          elegibilityInfo.healthSpecialistParticipationFlag &&
          elegibilityInfo.healthSpecialistParticipatedFlag === '1';
        this.eligibilityDetermination.certification =
          elegibilityInfo.eligibilityFlag === '1' &&
          elegibilityInfo.impedimentId != null;

        //Get Impediments
        this.eligibilityDetermination.impediment =
          elegibilityInfo.impedimentId != null
            ? this.determinationElegibilityOptions.impediments.find(
                (f) => f.id == elegibilityInfo.impedimentId
              )
            : null;

        this.eligibilityDetermination.severity =
          elegibilityInfo.impedimentSeverityCode != null
            ? this.determinationElegibilityOptions.severities.find(
                (f) => f.id == elegibilityInfo.impedimentSeverityCode
              )
            : null;

        this.eligibilityDetermination.disorders =
          elegibilityInfo.impedimentAutismCode != null
            ? this.determinationElegibilityOptions.disorders.find(
                (f) => f.id == elegibilityInfo.impedimentAutismCode
              )
            : null;
        //Hearing
        this.eligibilityDetermination.partialHearing =
          elegibilityInfo.impedimentPartialHearingFlag === '1';
        //Get Impediments Multiples
        if (
          elegibilityInfo.multipleImpedimentInfo &&
          elegibilityInfo.multipleImpedimentInfo.length > 0
        ) {
          elegibilityInfo.multipleImpedimentInfo.forEach(
            (multipleImpediment) => {
              let impediment = this.determinationElegibilityOptions.multipleImpediments.find(
                (x) => x.id === multipleImpediment.impedimentId
              );
              //Set Item
              let item = {};
              item.id = impediment.id;
              item.association = null;
              item.title = impediment.name;
              const severity = this.determinationElegibilityOptions.severities.find(
                (x) => x.id == multipleImpediment.severityId
              );
              const disorder = this.determinationElegibilityOptions.disorders.find(
                (x) => x.id == multipleImpediment.autismId
              );
              const partialHearing = multipleImpediment.partialHearingFlag;

              this.eligibilityDetermination.impedimentMultiple.selectedItems.push(
                item
              );
            }
          );
        }

        this.eligibilityDetermination.isConditionsInProcessNecessary = false;
        if (
          elegibilityInfo.eligibilityDeterminationConditions &&
          elegibilityInfo.eligibilityDeterminationConditions.length > 0
        ) {
          elegibilityInfo.eligibilityDeterminationConditions.forEach((x) => {
            let condition = this.determinationElegibilityOptions.conditions.find(
              (c) => c.id == x
            );

            //Set Item
            let item = {};
            item.id = condition.id;
            item.association = null;
            item.title = condition.name;
            item.code = condition.code;
            this.eligibilityDetermination.eligibilityDeterminationConditions.selectedItems.push(
              item
            );
          });
          this.eligibilityDetermination.isConditionsInProcessNecessary = true;
        }
        }
        //Change this;

        this.evaluationDateTypeCode =
          response.data.isSufficientFlag === '1'
            ? evaluationDateTypeCodes.triannualReview
            : evaluationDateTypeCodes.existingEvaluationAnalysis;
      });
    },
    //End Section Completed

    //Section II
    // Datos de componente BackupDocument. (Mejorar v-model)
    gettingBackupDocument(data) {
      this.backupDocumentsData = data;
    },
    gettingBackupDocumentAnalysys(data) {
      this.analysisDocuments = data;
    },
    //End Section
    //Section III Referido para solicitud de evaluación
    validateReferrals() {
      if (
        this.requestReferrals.referrals.length > 0 &&
        this.requestReferrals.referrals.some(
          (referral) =>
            referral.evaluation.id === evaluationTypes.Evaluacion_Trianual
        )
      ) {
        this.referralsData = this.requestReferrals.referrals.map((referral) => {
          return {
            academicyearid: this.generalInformationEligibility.academicYearId,
            studentsieid: this.selectedStudentSieId,
            disciplineid: referral.discipline.id,
            evaluationtypeid: referral.evaluation.id,
            evaluationtypename: referral.evaluation.name,
            evaluationdate: this.generalInformationEligibility.evaluationDate,
            referralrequestreason: referral.referralRequestReason,
            discipline: {
              id: referral.discipline.id,
              name: referral.discipline.name,
            },
            evaluation: {
              id: referral.evaluation.id,
              name: referral.evaluation.name,
            },
            status: referral.status,
            referralStatusId: referral.referralStatusId,
          };
        });
        this.hasSelectedReferralTrianual = true;
      } else {
        this.hasSelectedReferralTrianual = false;
      }
      return this.hasSelectedReferralTrianual;
    },
    //Section IV (Informacion de Evaluaciones)
    showAddPreviousModal() {
      this.openModal = true;
    },
    //Validations for Sections and BussinessLogic Section IV & V
    async validateEvaluationInformation() {
      //If Enought enoughInformation == true  or FromDetermination == true(for evaluated )
      let evaluationInformationValidated = await this.$refs.evaluationInformation.validate();
      //Only if vee-validate is true we review business logic
      if (evaluationInformationValidated) {
        //Get All evaluation selected & accepted
        let hasSelected =
          this.evaluationInformationLayout.evaluationInformationData.length > 0;

        let hasAccepted = this.evaluationInformationLayout.evaluationInformationData.every(
          (evaluation) => evaluation.isApprovedByParentFlag != null
        );

        // validate unique discipline
        const grouped = Object.values(
          this.$groupBy(
            this.evaluationInformationLayout.evaluationInformationData,
            (c) => c.disciplineTypeName
          )
        );

        let isUniqueDiscipline =
          grouped.find(
            (eva) => eva.filter((x) => x.isApprovedByParentFlag).length > 1
          ) == undefined;

        //validate determination
        /*  let hasDeterminated =
          this.evaluationInformationLayout.evaluationInformationData.find(
            (eva) =>
              eva.isDeterminated &&
              eva.disciplineTypeId != DISCIPLINE_TYPES.Ocupacional
          ) != undefined;*/

        //Required Impediment Multiples?
        // * Impediment Multiples Selected don't trigger this validation?
        const isRequireMultipleEvaluation = this.eligibilityDetermination
          .impediment
          ? this.impedimentRequireMultipleEvaluations.find(
              (f) => f.id == this.eligibilityDetermination.impediment.id
            )
          : null;
        const evaluationsDeterminatedSelected = this.evaluationInformationLayout.evaluationInformationData.filter(
          (x) => x.isDeterminated
        );

        let message = null;
        if (!hasSelected) {
          message = this.resources['R140001'];
        } else if (!hasAccepted) {
          message = this.resources['R140002'];
        } else if (!isUniqueDiscipline) {
          message = this.resources['22146'];
        } /* else if (!hasDeterminated) {
          message = this.resources['22147'];
        } */ else if (
          !this.eligibilityDetermination.impediment &&
          this.eligibilityDetermination.isElegibility
        ) {
          //todo validar user case (when this ocurred)
          message = ''; // Para que no ingrese al guardar. Habría que mostrar un mensaje si no se selecciono ningun empedimento.
        } else if (
          !isRequireMultipleEvaluation &&
          evaluationsDeterminatedSelected.length > 1
        ) {
          message = this.resources['22149'];
        } else if (
          isRequireMultipleEvaluation &&
          evaluationsDeterminatedSelected.length < 1
        ) {
          message = this.resources['22148'];
        } else if (this.eligibilityDetermination.impediment) {
          //Validate if impediment(s) is correct for evaluations selected.
          let impedimentForEvaluationSelection = [];
          let impediments = [];
          const impedimentMultiples = this.eligibilityDetermination
            .impedimentMultiple.selectedItems;
          if (impedimentMultiples.length > 1) {
            impediments.push(
              this.eligibilityDetermination.impedimentMultiple.selectedItems
            );
          } else {
            impediments.push(this.eligibilityDetermination.impediment);
          }

          //Valid if each multiple impediments has evaluation required
          let impedimentRequireEvaluations = this.impedimentRequireEvaluations;
          impediments.forEach((impediment) => {
            const evaluations = impedimentRequireEvaluations.find(
              (f) => f.id == impediment.id
            )?.evaluations;

            let evaluationsAvailables = null,
              existsEvaluation = true;
            if (impedimentMultiples.length > 0) {
              evaluationsDeterminatedSelected.forEach((x) => {
                existsEvaluation =
                  evaluations &&
                  evaluations.some(
                    (evaluation) => evaluation.name === x.disciplineTypeName
                  );
              });
            } else {
              evaluationsDeterminatedSelected.forEach((x) => {
                existsEvaluation =
                  evaluations &&
                  !evaluations.some(
                    (evaluation) => evaluation.name === x.disciplineTypeName
                  );
              });
            }

            if (existsEvaluation) {
              evaluations.forEach((evaluation) => {
                const html = `<strong>${evaluation.name}</strong>`;
                evaluationsAvailables =
                  evaluationsAvailables === null
                    ? html
                    : evaluationsAvailables + ', ' + html;
              });

              impedimentForEvaluationSelection.push({
                name: `<strong>${impediment.name}</strong>`,
                evaluations: evaluationsAvailables,
              });
            }
          });
          //Set all impediment selected in one message
          if (
            impedimentForEvaluationSelection &&
            impedimentForEvaluationSelection.length > 0
          ) {
            const last = impedimentForEvaluationSelection.length - 1;

            impedimentForEvaluationSelection.forEach((impediment, index) => {
              const html = last === index ? '' : '</br></br>';
              const msg = this.getResourceMessageWithFormat(
                '22150',
                impediment.name,
                impediment.evaluations
              );
              message = message ? message + msg + html : msg + html;
            });

            message += ' (22150)';
          }
        }
        this.evaluationErrorMessage = message;
        if (message == null) {
          evaluationInformationValidated = true;
        } else {
          evaluationInformationValidated = !(message.length > 0); //Invalid because has message
        }
      }
      //Force rejectAccept error msg (validate)
      this.existInvalidEvaluationReject = false;

      this.evaluationInformationLayout.evaluationInformationData.forEach(
        (value) => {
          if (
            !this.existInvalidEvaluationReject &&
            !value.isApprovedByParentFlag
          )
            this.existInvalidEvaluationReject =
              value.rejectionById == undefined &&
              (value.rejectionComment == undefined ||
                value.rejectionComment == '') &&
              !value.rejectionReasons?.length;
        }
      );
      return evaluationInformationValidated;
    },
    //End Section IV
    //Section V
    async getImpedimentOptions() {
      await studentTrianualService.getImpediments().then((res) => {
        this.determinationElegibilityOptions.impediments = res.data;
      });
      await studentTrianualService.getImpedimentsMultiple().then((res) => {
        this.determinationElegibilityOptions.multipleImpediments = res.data;
      });
      await studentTrianualService.getSeverities().then((res) => {
        this.determinationElegibilityOptions.severities = res.data;
      });
      await studentTrianualService.getDisorders().then((res) => {
        this.determinationElegibilityOptions.disorders = res.data;
      });
    },
    async getConditionsCatalog() {
      await studentTrianualService
        .getEligibilityDeterminationConditions()
        .then((res) => {
          this.determinationElegibilityOptionsOriginal = res.data;
          this.determinationElegibilityOptions.conditions = res.data;
        });
    },
    //End Section V
    async isValid() {
      let isValidated = true;
      this.validateComponent = true;
      let isValidMiunteDate = this.$refs.evaluationDocumentsBackup?.validDocumentDates();

      if (isValidMiunteDate === false) {
        this.ShowToast('Alerta', 'Información incompleta.', 'warning');
        isValidated = false;
      }

      if (
        this.generalInformationEligibility.enoughInformation &&
        this.$refs.evaluationDocumentsBackup?.hasAtLeastOneDocument() === false
      ) {
        this.ShowToast(
          'Alerta',
          'Debe añadir al menos un documento en la sección de Documentos Evaluados en el Análisis de información Existente.',
          'warning'
        );
        isValidated = false;
      }

      this.showErrorEvaluations =
        this.evaluationInformationLayout.evaluationInformationData != null &&
        this.evaluationInformationLayout.evaluationInformationData.length == 0;

      //Not Always visibles
      let validationArray = [
        this.$refs.generalInformationEligiblityA.validate(), //Section I
        this.$refs.evaluationInformation &&
          this.validateEvaluationInformation(), //Section IV
        this.$refs.eligibilityDetermination &&
          this.$refs.EligibilityDeterminationTriannual &&
          this.$refs.EligibilityDeterminationTriannual.validateImpediments() &&
          this.$refs.eligibilityDetermination.validate(), //Section X
        this.$refs.termsResponsability &&
          this.$refs.termsResponsability.validate(), //Section VII
      ];

      //Section III - solo se valida si no viene de una determinación
      if (this.isNotEnoughtInformation) {
        validationArray.push(this.validateReferrals());
        validationArray.push(this.$refs.documentDifficult.validateForm());
      }

      await Promise.all(validationArray).then((v) => {
        v.some((element) => {
          if (element == false) {
            this.ShowToast('Alerta', 'Información incompleta.', 'warning');
            isValidated = false;
          }
        });
      });

      // !Force Signature Validation (We need change this component for validate himeself)
      let isSignatureValid = true;

      for (let i = 0; i < this.signatureList.length; i++) {
        this.signatureList[i].isRequired = true;
      }
      isSignatureValid =
        !this.signatureList.filter(
          (f) =>
            (f.isRequired && f.signature.name == '') ||
            f.signature.positionId == undefined ||
            f.signature.participationId == undefined ||
            (f.signature.participationId == 1 &&
              f.participationId.alternateId == undefined)
        ).length > 0;
      //Re-validate if reject on clicked
      if (validationArray[1] && this.existInvalidEvaluationReject) {
        isValidated = false;
      }
      if (this.isFromDetailCoordination) {
        isValidated = isValidated;
        return isValidated;
      }
      isValidated = isValidated && isSignatureValid;
      return isValidated;
    },
    isCriterialDocumentsValid() {
      let isValid = true;
      const secondCriterialDocuments = this.existingDocuments?.files ?? [];
      if (
        this.generalInformationEligibility.enoughInformation &&
        secondCriterialDocuments.length > 0
      ) {
        const hasMissingDocument =
          this.hasCriterial2Error ||
          secondCriterialDocuments.some((d) => d.id === '' || d.id === null);
        if (hasMissingDocument) {
          this.ShowToast(
            'Información Incompleta',
            'Informe Académico no contiene documento.',
            'error'
          );
          isValid = false;
        }
      }

      return isValid;
    },
    async handleSubmit() {
      this.showErrorEvaluations = false;
      let isValid = await this.isValid();
      // Validate if has no document's IDs (Section Criteria 2)
      this.isCriteriaDocumentsValid = this.isCriterialDocumentsValid();
      if (!this.isCriteriaDocumentsValid) return;

      var isAQValid =
        !this.additionalQuestionsFlag || this.$refs.additionalQuestions.isValid;
      if (!isValid || !isAQValid) {
        this.ShowToast(
          'Información Incompleta',
          'Favor verificar y completar la información solicitada.',
          'error'
        );
        return;
      }

      //If with contact information or not
      if (!this.generalInformationEligibility.enoughInformation) {
        this.$refs.contactInfoModalRef.open();
      } else {
        this.send();
      }
    },
    cancelContactInfoModal() {
      // Intencionalmente se dejo blank
    },
    // Metodo para enviar info al backend
    async saveContactInfoModal(contactInfoParams) {
      this.studentContactInformation = contactInfoParams;
      this.send();
    },
    async send() {
      this.referralsData?.forEach(
        (r) => (r.studentsieid = parseInt(r.studentsieid))
      );
      const eligibilityEvaluationInfo = this.evaluationInformationLayout.evaluationInformationData.map(
        (obj) => ({
          ...obj,
          rejection: undefined,
          discussionStatusId: this.showAsDiscussion
            ? obj.discussionStatusId
            : obj.isApprovedByParentFlag
            ? discussionStatuses.accepted
            : discussionStatuses.rejected,
        })
      );
      const isEligibility = this.eligibilityDetermination.isElegibility;

      let eligibilityFlag = null;
      if (isEligibility === true) {
        eligibilityFlag = '1';
      } else if (isEligibility === false) {
        eligibilityFlag = '0';
      }

      let data = {
        //Section I
        studentSieid: this.selectedStudentSieId,
        academicYearId: this.generalInformationEligibility.academicYearId,
        reevaluationTime: this.reevaluationTime,
        difficultyProgress: this.difficultyProgress,
        academicYearDesc: this.generalInformationEligibility
          .academicYearDescription,
        evaluationDate: this.generalInformationEligibility.evaluationDate,
        evaluationDateTypeCode:
          this.generalInformationEligibility.enoughInformation ||
          this.isFromDetermination
            ? evaluationDateTypeCodes.triannualReview
            : evaluationDateTypeCodes.existingEvaluationAnalysis,
        commentDescription: '',
        impedimentChangeFlag: this.generalInformationEligibility
          .enoughInformation,
        isSufficientFlag: this.generalInformationEligibility.enoughInformation
          ? '1'
          : '0',
        hasEligibilityFlag: this.generalInformationEligibility
          .enoughInformation,
        //End Section I
        elegibilityInfo: {
          impedimentsOptions: this.eligibilityDetermination.impedimentsOptions,
          //Section V (Determination Elegibility)
          eligibilityDeterminationDate: this.generalInformationEligibility
            .evaluationDate,

          eligibilityFlag: eligibilityFlag,
          impedimentId: this.eligibilityDetermination.impediment?.id,
          impedimentSeverityCode: this.eligibilityDetermination.severity?.id,
          impedimentAutismCode: this.eligibilityDetermination.disorders?.id,
          impedimentPartialHearingFlag: this.eligibilityDetermination
            .partialHearing
            ? '1'
            : '0',
          dissabilityOption:
            this.eligibilityDetermination.dissabilityOption == null
              ? null
              : this.eligibilityDetermination.dissabilityOption,
          eligibilityComment: this.eligibilityDetermination.comments,
          healthSpecialistParticipationFlag: this.eligibilityDetermination
            .isHealthSpecialistNecessary
            ? '1'
            : '0',
          healthSpecialistParticipatedFlag: this.eligibilityDetermination
            .participatedSpecialist
            ? '1'
            : '0',
          postEligibilityMeetingsQty: this.eligibilityDetermination.meetingQty
            ?.id,
          multipleImpedimentInfo: this.eligibilityDetermination.impedimentMultiple.selectedItems.map(
            (item) => {
              let impedimentItem = {
                impedimentId: item.id,
                severityId:
                  item.title === ImpedimentsEnum.MR_DiscapacidadIntelectual
                    ? item.association
                    : null,
                autismId:
                  item.title === ImpedimentsEnum.AUT_Autismo
                    ? item.association
                    : null,
                partialHearingFlag:
                  item.title === ImpedimentsEnum.HI_ProblemaAudicion
                    ? item.association == 'true'
                      ? '1'
                      : '0'
                    : null,
                name:
                  item.title === ImpedimentsEnum.MR_DiscapacidadIntelectual ||
                  item.title === ImpedimentsEnum.AUT_Autismo ||
                  item.title === ImpedimentsEnum.HI_ProblemaAudicion
                    ? item.title
                    : item.name,
              };
              return impedimentItem;
            }
          ),
          conditionsInProcessNecessaryFlag:
            this.eligibilityDetermination.isConditionsInProcessNecessary == null
              ? false
              : this.eligibilityDetermination.isConditionsInProcessNecessary,
          eligibilityDeterminationConditions: this.eligibilityDetermination.eligibilityDeterminationConditions.selectedItems.map(
            (c) => c.id
          ),
          // End Section V
          //Section IV
          eligibilityEvaluationInfo,
          // End Section IV
          //Section VI
          attendanceInfo: this.getSignatureList(),
          //End Section VI
          DocumentAttachmentInfo: [],
        },
        placementCommittee: {
          committeeDate: new Date(
            this.generalInformationEligibility.evaluationDate
          ),
          placementCommittee: this.placementCommitteeId,
          academicYearId: this.generalInformationEligibility.academicYearId,
          committeeDescription: this.evaluationDescription,
          placementCommitteeCategoryId: this.placementCommitteeCategoryId,
          impedimentChangeFlag: this.generalInformationEligibility
            .enoughInformation,
        },
        //Section III
        referrals: this.referralsData,
        isFromDetailCoordination:
          this.$route.query.isFromDetailCoordination === 'true',
        // End Section III
        //Section Zero
        studentcontactinformation: this.studentContactInformation,
        //End Section Zero
      };

      if (data.conditionsInProcessNecessaryFlag) {
        data.eligibilityDeterminationConditions = this.eligibilityDetermination.eligibilityDeterminationConditions.selectedItems.map(
          (c) => c.id
        );
      }

      //Section II
      if (
        this.backupDocumentsData != null &&
        this.backupDocumentsData.types.length > 0
      ) {
        this.backupDocumentsData.files.forEach((item, index) => {
          const documentIds = item.id?.split(',') ?? [];
          documentIds.forEach((id) => {
            let file = {
              documentId: id,
              DocumentName: item.name,
              DocumentTypeId: this.backupDocumentsData.types[index]
                .documentTypeId,
            };
            data.elegibilityInfo.DocumentAttachmentInfo.push(file);
          });
        });

        if (data.documentTypes == undefined) {
          data.documentTypes = [];
        }

        (this.backupDocumentsData.types || []).forEach((type) => {
          const documentIds = type.documentId?.split(',') ?? [];
          documentIds.forEach((id) => {
            let file = { ...type, documentId: id };
            data.documentTypes.push(file);
          });
        });
      }
      //End Section II
      //TODO for Edit trianuals evaluations
      if (this.evaluationDateId != undefined) {
        data.evaluationDateId = Number(this.evaluationDateId);
      }
      if (this.additionalQuestionsFlag) {
        this.$refs.additionalQuestions.mapQuestionsAnswers();
        data.StudentExitAdditionalQuestions = this.$refs.additionalQuestions.PeiAdditionalQuestionsToDB;
      }
      data.documentAnalysis = this.analysisDocuments;
      let formData = objectToFormData(data, { indices: true });
      if (this.analysisDocuments != null && this.analysisDocuments.length > 0) {
        this.analysisDocuments.forEach((document, index) => {
          // Agregar cada documento al FormData con un nombre único
          formData.append(`analysisDocuments`, document.attachment);
        });
      }
      if (
        this.backupDocumentsData != null &&
        this.backupDocumentsData.types.length > 0
      ) {
        this.backupDocumentsData.files.map((file) => {
          formData.append(`documents`, file);
        });
      }
      // * Send Data
      if (isEligibility === false) {
        const isConfirmed = await this.ShowCancelModal(
          'Confirmación',
          `<div class="mb-3"> Al continuar con esta acción, el estudiante cambiará a estatus Egreso. Esto dejará sin efecto lo siguiente:</div>
                <ul>
                  <li class="mb-2"> Cancelará los referidos activos de evaluaciones </li>
                  <li class="mb-2"> Cancelará los referidos de terapia cambiaran a estatus No Vigente: Egreso </li>
                  <li class="mb-2"> Los proveedores de servicios no podrán facturas servicios a partir de esta fecha. </li>
                  <li class="mb-2"> Cancelará la elegibilidad para las solicitudes de transportación escolar. </li>
                </ul>
              `,
          'Si',
          'No'
        );

        if (!isConfirmed) return;
      }

      let loadData = false;

      if (this.evaluationDateId == undefined) {
        try {
          const res = await studentEvaluationService.saveEvaluation(formData);
          this.requestReferrals.referrals = res.data.referrals;
          this.evaluationDateId = res.data.evaluationDateId;
          this.requestReferrals.referralForEvaluationRequestKey++;
          loadData = true;
        } catch (error) {
          const message = !error.response?.data
            ? DEAFULT_MSG_ERROR
            : error.response.data.message;
          this.ShowToast('  Error', message);

          return;
        }
      } else {
        let newData = { ...data, studentSieid: parseInt(data.studentSieid) };
        await studentEvaluationService
          .updateEvaluation(newData)
          .then((res) => {
            this.referrals = res.data;
            this.requestReferrals.referralForEvaluationRequestKey++;
            loadData = true;
          })
          .catch(() => {
            this.ShowToast(DEAFULT_MSG_ERROR, 'error');
          });
      }

      if (loadData) {
        if (this.generalInformationEligibility?.enoughInformation) {
          this.submitted = true;
        }
        await this.changeSelectedStudentImpediment();

        if (hasRejectedEvaluations && isEligible) {
          const isRedirectNeeded = await this.ShowCancelModal(
            'Confirmación',
            '¿Desea generar un referido de evaluación independiente a través del mecanismo de remedio provisional?',
            'Si',
            'No'
          );
          if (isRedirectNeeded) {
            const rejectedEvaluationIds = eligibilityEvaluationInfo
              .filter(
                (x) => x.discussionStatusId == discussionStatuses.rejected
              )
              .map((x) => x.studentEvaluationId);

            this.$router.push({
              name: `MainCreateRpRequest`,
              params: { StudentSieId: data.studentSieid },
              query: { RejectedEvaluationIds: rejectedEvaluationIds },
            });
            return;
          }
        }

        this.ShowToast(
          'Proceso exitoso.',
          'Su información ha sido guardada.',
          'success'
        );
      }

      store.dispatch('$_student/refreshStudentMainInfo');
      if (this.isFromDetailCoordination) {
        let isValid = await this.$refs.ReferralForEvaluationRequest.isValid();
        if (!isValid) {
          this.ShowToast(
            'Información Incompleta',
            'Favor verificar y completar la información solicitada.',
            'error'
          );
          return;
        }
        let dataToSend = {
          listReferralStatus: this.referrals.map((referral) => ({
            id: referral.studentReferralId,
            reason: referral.referralRequestReason,
          })),
        };

        await studentEvaluationServices.updateReferralStatusReason(dataToSend);
        this.$router.push({ name: 'EvaluationRequestManagement' });
        return;
      }

      if (this.isNotEnoughtInformation && this.isUserPilotPlan) {
        this.$router.replace({
          name: 'evaluations-appointment',
          params: {
            isFromTrianual: true,
            evaluationDateId: this.evaluationDateId,
            isFromDetermination: this.isFromDetermination,
          },
        });
      } else {
        this.$router.push({ path: '/student' });
      }
    },
    navigate() {
      if (this.fromRoute.toward != undefined) {
        this.$router.push({ ...this.fromRoute.toward });
      } else if (this.isFromDetailCoordination) {
        this.$router.push({ name: 'EvaluationRequestManagement' });
      } else {
        this.$router.push({ name: 'TriannualProcessMain' });
      }
    },
    //Signature Managment methods
    addSignature() {
      this.signatureCounter -= 1;
      this.signatureList.push({
        id: this.signatureCounter,
        signature: {
          name: '',
          positionId: undefined,
          participationId: undefined,
          alternateId: undefined,
        },
        groupId: 0,
        isRequired: this.validateComponent,
        isRemovable: true,
        isDisabled: false,
      });
    },
    async updateStudentImpediment() {
      await compuHistoryServices.updateImpedimentInfo(
        this.$store.getters['$_student/StudentSie'] ?? this.sieByParam
      );
    },
    async changeSelectedStudentImpediment() {
      if (
        this.eligibilityDetermination.impediment &&
        !this.isFromDetailCoordination
      ) {
        await this.updateStudentImpediment();
        this.$store.state.$_student.selectedStudent.impediment = this.eligibilityDetermination.impediment?.name;
      }
    },
    deleteSignature(id) {
      let signatureListIndex = this.signatureList.findIndex((e) => e.id === id);
      this.signatureList.splice(signatureListIndex, 1);
    },
    //Mejora al control (usar v-model para evitar estos cambios)
    getBasicSignature(groupId) {
      //TODO validate information about signatures
      let signature;
      if (this.elegibilitySignatureList != null) {
        signature = this.elegibilitySignatureList.find((x) =>
          this.availableSignatureOptions.some(
            (y) =>
              y.signatureGroupId == groupId &&
              y.signaturePositionId == x.positionCode
          )
        );
      }
      if (signature != undefined) {
        return {
          id: signature.id,
          signature: {
            name: signature.fullName,
            positionId: { signaturePositionId: signature.positionCode },
            participationId: { id: signature.participationTypeId },
            alternateId: { id: signature.alternateParticipationTypeId },
          },
          groupId: groupId,
          isRequired: this.validateComponent,
          isRemovable: false,
          isDisabled: false,
        };
      } else {
        this.signatureCounter -= 1;
        return {
          id: this.signatureCounter,
          signature: {
            name: '',
            positionId: undefined,
            participationId: undefined,
            alternateId: undefined,
          },
          groupId: groupId,
          isRequired: this.validateComponent,
          isRemovable: false,
        };
      }
    },
    getBasicSignatureWithoutCometee(groupId) {
      //TODO validate information about signatures
      let signature;
      if (this.signatureListWithoutCometee != null) {
        signature = this.signatureListWithoutCometee.find((x) =>
          this.availableSignatureOptions.some(
            (y) =>
              y.signatureGroupId == groupId &&
              y.signaturePositionId == x.positionCode
          )
        );
      }
      if (signature != undefined) {
        return {
          id: signature.id,
          signature: {
            name: signature.fullName,
            positionId: { signaturePositionId: signature.positionCode },
            participationId: { id: signature.participationTypeId },
            alternateId: { id: signature.alternateParticipationTypeId },
          },
          groupId: groupId,
          isRequired: this.validateComponent,
          isRemovable: false,
          isDisabled: this.participantSignaturesReadOnly,
        };
      } else {
        this.signatureCounter -= 1;
        return {
          id: this.signatureCounter,
          signature: {
            name: '',
            positionId: undefined,
            participationId: undefined,
            alternateId: undefined,
          },
          groupId: groupId,
          isRequired: this.validateComponent,
          isRemovable: false,
          isDisabled: this.participantSignaturesReadOnly,
        };
      }
    },
    getSignatureList() {
      let self = this;
      let signatures = [];
      self.signatureList.forEach((x) => {
        let signInfo = {
          id: x.id,
          fullName: x.signature.name,
          positionId: x.signature.positionId?.signaturePositionId,
          participationType: x.signature.participationId?.id,
          alternateParticipationType: x.signature.alternateId
            ? x.signature.alternateId.id
            : undefined,
          IsRequired: !x.isRemovable,
        };
        signatures.push(signInfo);
      });
      return signatures;
    },
    loadSignatures() {
      let self = this;
      if (this.elegibilitySignatureList == undefined) {
        return;
      }
      this.elegibilitySignatureList.forEach(function(signature) {
        if (!self.signatureList.some((x) => x.id == signature.id)) {
          self.signatureList.push({
            id: signature.id,
            signature: {
              name: signature.fullName,
              positionId: {
                signaturePositionId: Number(signature.positionCode),
              },
              participationId: { id: Number(signature.participationTypeId) },
              alternateId: { id: signature.alternateParticipationTypeId },
            },
            groupId: 13,
            isRequired: self.shouldValidate,
            isRemovable: !self.participantSignaturesReadOnly,
            isDisabled: self.participantSignaturesReadOnly,
          });
        }
      });
      //Remove all signatures with id = -1 disabled
      if (self.participantSignaturesReadOnly) {
        let signaturesToRemove = this.signatureList.filter((x) => x.id < 0);
        if (this.signatureList.length > 3 && signaturesToRemove.length > 0) {
          //Only one
          signaturesToRemove.forEach((signature) => {
            this.deleteSignature(signature.id);
          });
        }
      }
    },
    loadSignaturesWithoutCometee() {
      //signatureListWithoutCometee
      let self = this;
      if (this.signatureListWithoutCometee == undefined) {
        return;
      }
      this.signatureListWithoutCometee.forEach(function(signature) {
        if (!self.signatureList.some((x) => x.id == signature.id)) {
          self.signatureList.push({
            id: signature.id,
            signature: {
              name: signature.fullName,
              positionId: { signaturePositionId: signature.positionCode },
              participationId: { id: Number(signature.participationTypeId) },
              alternateId: { id: signature.alternateParticipationTypeId },
            },
            groupId: 13,
            isRequired: self.shouldValidate,
            isRemovable: !self.participantSignaturesReadOnly,
            isDisabled: self.participantSignaturesReadOnly,
          });
        }
      });
      //Remove all signatures with id = -1 disabled
      if (self.participantSignaturesReadOnly) {
        let signaturesToRemove = this.signatureList.filter((x) => x.id < 0);
        if (this.signatureList.length > 3 && signaturesToRemove.length > 0) {
          //Only one
          signaturesToRemove.forEach((signature) => {
            this.deleteSignature(signature.id);
          });
        }
      }
    },
    async setSignatureConfig() {
      //** Positions for Signatures */ */
      let self = this;
      await signatureService.getPositions().then((result) => {
        self.availableSignatureOptions = result.data;
      });

      //*****signature Management********
      if (this.signatureListWithoutCometee.length != 0) {
        this.configSignatureWithoutCometee();
        return;
      }
      this.signatureList = [];
      //getting default Signatures
      let signature1 = this.getBasicSignature(1);
      if (signature1 != undefined) {
        this.signatureList.push(signature1);
      }
      let signature5 = this.getBasicSignature(5);
      if (signature5 != undefined) {
        this.signatureList.push(signature5);
      }

      let signature6 = this.getBasicSignature(4);
      if (signature6 != undefined) {
        this.signatureList.push(signature6);
      }
      this.loadSignatures();
    },
    configSignatureWithoutCometee() {
      this.signatureList = [];
      //getting default Signatures
      let signature1 = this.getBasicSignatureWithoutCometee(1);
      if (signature1 != undefined) {
        this.signatureList.push(signature1);
      }
      let signature5 = this.getBasicSignatureWithoutCometee(5);
      if (signature5 != undefined) {
        this.signatureList.push(signature5);
      }

      let signature6 = this.getBasicSignatureWithoutCometee(4);
      if (signature6 != undefined) {
        this.signatureList.push(signature6);
      }
      this.loadSignaturesWithoutCometee();
    },
    addSpecialistSignature() {
      let existSpecialistRow = this.signatureList.find(
        (x) => !x.isRemovable && x.signature.positionId == 850
      );
      if (!existSpecialistRow) {
        this.signatureCounter -= 1;
        this.signatureList.push({
          id: this.signatureCounter,
          signature: {
            name: '',
            positionId: { signaturePositionId: 850 },
            participationId: undefined,
            alternateId: undefined,
          },
          groupId: 13,
          isRequired: this.validateComponent,
          isRemovable: false,
          isDisabled: false, //Search PositionId for specialist
          positionDisabled: true,
        });
      }
    },
    removeSpecialistSignature() {
      //this.signatureList.push(specialistSignature);
      let existSpecialistRow = this.signatureList.find(
        (x) =>
          !x.isRemovable &&
          x.signature.positionId &&
          x.signature.positionId.signaturePositionId == 850
      );
      if (existSpecialistRow) {
        this.deleteSignature(existSpecialistRow.id);
      }
    },
    async getParticipationTypeList() {
      await this.$ApiGet('/api/pei/participationTypeList')
        .then((res) => {
          this.participationTypeList = res.data;
        })
        .catch((err) => {
          this.response = err;
        });
    },
    async getAlternateParticipationTypeList() {
      await this.$ApiGet('/api/pei/alternateParticipationTypeList')
        .then((res) => {
          this.alternateParticipationTypeList = res.data;
        })
        .catch((err) => {
          this.response = err;
        });
    },
    //End Signatures Methods
    //Section Evaluation
    async getEvaluationInformation(
      evaluationsAddedList,
      evaluationsExcludedList = undefined,
      isInitialPostRegistry,
      evaluationServiceType,
      disabled,
      evaluationDateId
    ) {
      const payload = {
        StudentSieID: this.$store.getters['$_student/StudentSie'],
        ComparisonDate: null,
        IsEnoughInformation: this.generalInformationEligibility
          ?.enoughInformation,
        EvaluationServiceType:
          evaluationServiceType == undefined ? 2 : evaluationServiceType, // 2=additionalEvaluation enum type
        ExcludedEvaluations:
          evaluationsExcludedList != undefined
            ? evaluationsExcludedList.map((x) => x.value).join(', ')
            : '',
        SelectedEvaluations:
          evaluationsAddedList != undefined
            ? [...new Set(evaluationsAddedList.map((x) => x.value))].join(', ')
            : '',
        evaluationDateId: evaluationDateId,
        IsInitialPostRegistry: isInitialPostRegistry,
        isDisabled: disabled == undefined ? this.isDisabled : disabled,
      };
      try {
        const {
          data,
        } = await studentEvaluationService.getEvaluationForEligilibility(
          payload
        );

        data.forEach((e) => {
          e.editable = e.statusId == -1 && e.isApprovedByParentFlag == null;
          //The evaluations can discuss again for trianual
          e.editable = [
            'Previa',
            'Confirmada',
            'Realizada por Remedio Provisional',
          ].includes(e.statusName);
          e.isSelectedFlag = e.isDeterminated = e.isImpedimentEvaluationFlag;
          e.isSelectedFlag = e.isApprovedByParentFlag != null;
          //Vm for Reject section
          e.isAcceptedDisabled = e.isApprovedByParentFlag != null;
          e.rejection = {
            rejectionById: { id: e.rejectionById, name: e.rejectionByName },
            rejectionComment: e.rejectionComment,
          };
          e.isOpened = false;
        });

        let uniqArray = this.$deleteArrayDuplicates(
          data,
          'studentEvaluationId'
        );
        this.tempEvaluations = uniqArray;
        if (evaluationDateId || evaluationsAddedList.length) {
          this.evaluationInformationLayout.evaluationInformationData = this.evaluationInformationLayout.evaluationInformationData.filter(
            (x) =>
              evaluationsAddedList
                .map((y) => Number(y.value))
                .includes(x.studentEvaluationId)
          );

          const news = uniqArray.filter(
            (x) =>
              !this.evaluationInformationLayout.evaluationInformationData
                .map((y) => y.studentEvaluationId)
                .includes(x.studentEvaluationId)
          );

          news.forEach((e) =>
            this.evaluationInformationLayout.evaluationInformationData.push(e)
          );

          this.evaluationInformationLayout.evaluationsAddedList = this.evaluationInformationLayout.evaluationInformationData.map(
            (e) => e.studentEvaluationId
          );
        } else {
          this.evaluationInformationLayout.evaluationInformationData = [];
          this.evaluationInformationLayout.evaluationsAddedList = [];
        }
      } catch (err) {
        this.response = err;
      }
    },
    async selectedEvaluationsModalSaveHandler(
      evaluationsAddedList,
      evaluationsExcludedList
    ) {
      await this.getEvaluationInformation(
        evaluationsAddedList,
        evaluationsExcludedList
      );
    },
    async getAvailablesEvaluations() {
      let self = this;
      let model = {
        studentSieId: this.$store.getters['$_student/StudentSie'],
        endDate: '',
        selectedEvaluations: self.evaluationInformationLayout.evaluationsAddedList.join(
          ', '
        ),
      };
      await studentEvaluationService
        .getAvailablesEvaluations(model)
        .then((res) => {
          self.evaluationInformationLayout.availables = res.data || [];
        });
    },
    async getEvaluationAvailables(ids) {
      let self = this;
      await studentEvaluationService.getSelectedEvaluations(ids).then((res) => {
        self.evaluationInformationLayout.availables = res.data || [];
      });
    },
    //End Section Evaluation
    //Reset models
    async reset() {
      if (!this.isDisabled) {
        if (this.generalInformationEligibility.enoughInformation) {
          this.eligibilityDetermination.dateEligibility = this.generalInformationEligibility.evaluationDate;
          this.requestReferrals = {
            referrals: [],
            referralForEvaluationRequestKey: 0,
          };
          (this.hasSelectedReferralTrianual = undefined),
            (this.info = {
              termsAccepted: null,
            });
        } else {
          this.existingDocuments = {
            files: [],
            types: [],
          };
          this.backupDocumentsData = {
            files: [],
            types: [],
          };

          this.existInvalidEvaluationReject = false;
          this.evaluationInformationLayout.evaluationInformationData = [];
          this.evaluationInformationLayout.evaluationsAddedList = [];
          this.openModal = false; //Add Previous Evaluations
          this.evaluationErrorMessage = null;
          //End Section IV
          //Section V (Determinacion)
          this.eligibilityDetermination = {
            dateEligibility: this.generalInformationEligibility.evaluationDate, // type: [Date, String],
            isElegibility: null,
            dissabilityOption: null,
            comments: '', //String
            meetingQty: null, //Object
            isHealthSpecialistNecessary: null, //Bool
            participatedSpecialist: null, //Bool
            certification: null,
            impediment: null,
            severity: null,
            disorders: null,
            partialHearing: null,
            //Multiple
            impedimentMultiple: {
              impediment: null,
              selectedItems: [],
            }, //Object
            severityMultiple: null,
            disordersMultiple: null, //Object
            partialHearingMultiple: null, //Object
            eligibilityDeterminationConditions: {
              condition: null,
              selectedItems: [],
            },
          };
          //End Section V
          //Section VI (Firmas)
          //signature Managment properties
          this.signatureCounter = 0;
          this.signatureList = [];
          this.componentKey = 0;

          await this.setSignatureConfig(); //Reset Signature options
          //End Section VI
          //Section VII Terminos
        }
      }
    },
    async goToDownloadEE05Report(evaluationDateId, isFromTriannual = false) {
      let self = this;
      let promise = new Promise((resolve) => {
        self
          .$ApiGet(
            `/api/studentevaluation/${this.$store.getters.SelectedStudent.studentId}/TrianualEligibilityDeterminationForm/${evaluationDateId}/${isFromTriannual}`
          )
          .then((res) => {
            self.report = res.data;
            generalService.documentDownloadReport(
              self.report.content,
              self.report.filename
            );
            resolve(res.data);
          })
          .catch((err) => {
            self.response = err;
          });
      });
      return promise;
    },
    // * Utility Methods
    getResourceMessageWithFormat(codeError, ...values) {
      let message = this.resources[codeError];

      if (message && values && values.length > 0) {
        for (let i = 0; i < values.length; i++) {
          const regexp = new RegExp('\\{' + i + '\\}', 'gi');
          message = message.replace(regexp, values[i]);
        }

        return message;
      }
    },
    // * End Utility
  },
  watch: {
    'generalInformationEligibility.evaluationDate'(newValue) {
      this.eligibilityDetermination.dateEligibility = newValue;
    },
    'eligibilityDetermination.participatedSpecialist'(value) {
      if (value == true) {
        this.addSpecialistSignature();
      } else {
        this.removeSpecialistSignature();
      }
    },
    'eligibilityDetermination.isElegibility'(value) {
      this.additionalQuestionsFlag =
        this.generalInformationEligibility.academicYearId != null &&
        !value &&
        !this.submitted;
    },
    'info.termsAccepted'(value) {
      if (!value) {
        //only if is false = null for validate trigged, yes i know i can use required_if (but when make this refactory doesnt work)
        this.info.termsAccepted = null;
      }
    },
    'generalInformationEligibility.enoughInformation'(newVal) {
      if (!newVal) {
        this.determinationElegibilityOptions.conditions = this.determinationElegibilityOptionsOriginal;
      }
    },
  },
  computed: {
    academicYear() {
      return {
        year: this.generalInformationEligibility.academicYear,
        description: this.generalInformationEligibility.academicYearDescription,
        id: this.generalInformationEligibility.academicYearId,
      };
    },

    isNotEnoughtInformation() {
      if (
        (this.generalInformationEligibility?.enoughInformation == undefined ||
          this.generalInformationEligibility?.enoughInformation == null) &&
        !this.isFromDetermination
      ) {
        return undefined;
      }
      // Call Clean
      return (
        this.generalInformationEligibility?.enoughInformation !== undefined &&
        this.generalInformationEligibility?.enoughInformation != null &&
        !this.generalInformationEligibility?.enoughInformation &&
        !this.isFromDetermination
      );
    },
    showSection() {
      return (
        this.generalInformationEligibility.enoughInformation ||
        this.isFromDetermination
      );
    },
    isDisabled() {
      return this.submitted || this.evaluationDateId != undefined;
    },
    hasSelectedStudent() {
      return store.getters.IsValidSelectedStudent;
    },
    userHasCreateAccess() {
      return true;
    },
    fromRoute() {
      return this.$router.app._route.params;
    },
    selectedStudentSieId() {
      if (this.sieByParam) return this.sieByParam;

      return this.$store.getters.SelectedStudent.studentId;
    },
    referrals() {
      return this.requestReferrals.referrals;
    },
    isUserPilotPlan() {
      return store.getters['$_user/pilotPlan'];
    },
  },
};
</script>

<style scope>
form {
  width: 100%;
}
</style>
<style src="@/assets/css/component/messages.css"></style>
<style scoped>
.disabled-page {
  pointer-events: none;
}

.wrapper-block {
  cursor: not-allowed !important;
}

.mv {
  margin-right: 1.75%;
}

.disabled-page {
  pointer-events: none;
}

.wrapper-block {
  cursor: not-allowed !important;
}

form {
  width: 100%;
}

.error-margin-left {
  margin-left: -20px !important;
}

.custom-chips >>> .chips-container {
  margin-top: -30px;
}

.custom-chips >>> .chips {
  margin-left: -2px;
  margin-right: 50px;
}

.b {
  font-weight: bolder !important;
}

.tag-badge {
  display: inline-block;
  padding-right: 1em;
  height: 42px;
  background: transparent linear-gradient(90deg, #ffffff 0%, #e8e8e8 100%) 0% 0%
    no-repeat padding-box;
  border-radius: 26px;
  cursor: pointer;
  margin-bottom: 10px;
}

.dot {
  width: 35px;
  height: 35px;
  border-radius: 50%;
  display: inline-block;
  /* top: 268px; */
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #00000029;
  padding-top: 9px;
}

.orange-icon {
  color: #ff7058;
}

.orange-icon-badge-align {
  vertical-align: top;
}

.tag-badge-title {
  text-align: left;
  font: Bold 25px/30px Lato;
  letter-spacing: 0;
  color: #11291b;
  display: inline-block;
}

.item-pane {
  justify-content: space-between;
  min-width: 50%;
  box-shadow: -3px 1px 3px #00000029;
  margin-top: 10px;
  display: flex;
  border-bottom: solid 1px #e2e2e2;
}

.item-pane-info {
  background: #f2f2f2 0% 0% no-repeat padding-box;
  border-radius: 0px 0px 5px 5px;
  margin-bottom: 10px;
  font: 400 14px/17px Lato;
  letter-spacing: 0;
  color: #11291b;
  padding: 20px 10px 10px;
}

.item-pane-info p {
  margin-bottom: 10px;
}

.item-pane-info p i {
  margin-right: 8px;
  font-size: 16px;
}

.border-box {
  border: 1px solid #e2e2e2;
  border-radius: 5px 5px 0px 0px;
  padding: 20px;
  width: 100%;
}

.border-box.gray {
  border-radius: 0px 0px 5px 0px;
  background: #f2f2f2 0% 0% no-repeat padding-box;
  border-top: none;
  padding: 20px 0;
}

.border-box.gray.error {
  background: #ffebeb 0% 0% no-repeat padding-box;
  border: 1px solid #c9545e;
}

.invalid {
  text-align: left;
  font: Lato, Regular;
  letter-spacing: 0;
  color: #ff5b5c;
  margin-bottom: 5px;
  font-weight: normal;
}

i.far.fa-check-circle {
  font-size: 24px;
  padding-right: 4px;
  line-height: 18px;
  margin-left: 4px;
}
</style>
